export default "__VITE_ASSET__Dh1o4UgU__"